import styled from 'styled-components';

export const Clock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    flex-direction: row;
    color: ${(props) => props.color};
`;

export const Group = styled.div`
    width: 74px;
    font-size: 18px;
    &.clock-divider {
        width: 16px;
    }
`;

export const GroupValue = styled.div``;
export const GroupLabel = styled.div`
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 500;
`;

export const ExpireTime = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    flex-direction: column;
`;

export const Title = styled.div`
    text-align: center;
    color: #585858;
    font-size: 26px;
    line-height: 28px;
    font-weight: 600;
    margin: auto;
    margin-bottom: 25px;
`;
